import { Tile } from '../Tile';
import { DiamondBaseColor, DiamondBasePosition } from '../Tile/utils';

export const LockedTile = () => {
  return (
    <Tile color={DiamondBaseColor.gray} position={DiamondBasePosition.middle} />
  );
};
